// client/src/dnd/emitter_tool/components/stages/TokenStage.js
import React, { useEffect, useRef } from "react";
import * as PIXI from "pixi.js";
import { buildToken } from "../../hooks/token";

export default function TokenStage({ enabled = true, startPos = { x: 180, y: 180 }, onPositionChange }) {
  const mountRef = useRef(null);
  const appRef = useRef(null);
  const tokenRef = useRef(null);

  useEffect(() => {
    const mount = mountRef.current;
    if (!mount || appRef.current) return;

    const app = new PIXI.Application({
      antialias: true, backgroundAlpha: 0, resizeTo: mount, powerPreference: "high-performance",
    });
    app.stage.sortableChildren = true;
    mount.appendChild(app.view);
    appRef.current = app;

    tokenRef.current = buildToken(app, startPos, (finalPos) => {
      try { onPositionChange?.({ x: finalPos.x, y: finalPos.y }); } catch {}
    });

    if (tokenRef.current?.layer) tokenRef.current.layer.visible = !!enabled;
    app.stage.addChild(tokenRef.current.layer);
    app.stage.sortChildren();

    try { onPositionChange?.({ x: startPos.x, y: startPos.y }); } catch {}

    return () => {
      try { tokenRef.current?.destroy?.(); } catch {}
      tokenRef.current = null;
      try { mount.removeChild(app.view); } catch {}
      app.destroy(true, { children: true, texture: false, baseTexture: false });
      appRef.current = null;
    };
  }, []);

  useEffect(() => {
    if (tokenRef.current?.layer) tokenRef.current.layer.visible = !!enabled;
  }, [enabled]);

  return <div ref={mountRef} style={{ position: "absolute", inset: 0, pointerEvents: "auto" }} />;
}
